import type { orderItem as OrderItemType } from './VerificationType'
import { Grid, Box, Typography, Button, Collapse } from '@mui/material'
import { useState } from 'react'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import InboundConfig from './InboundConfig'
import ProfessionalRecordingConfig from './ProfessionalRecordingConfig'
import LiveAnsweringConfig from './LiveAnsweringConfig'
import AnalytixConfig from './AnalytixConfig'
import CommscodeConfig from './CommscodeConfig'
import BusinessIntroConfig from './BusinessIntroConfig'

const VerificationNewItem = ({ orderItem }: { orderItem: OrderItemType }) => {
  const [showConfig, setShowConfig] = useState(false)
  let totalSubscription: number = 0
  let totalOnceoff: number = 0

  const provisioningModule = [
    {
      module: 'inbound1300',
      page: <InboundConfig orderItem={orderItem}/>
    },
    {
      module: 'inbound1800',
      page: <InboundConfig orderItem={orderItem}/>
    },
    {
      module: 'inbound13',
      page: <InboundConfig orderItem={orderItem}/>
    },
    {
      module: 'professionalrecording',
      page: <ProfessionalRecordingConfig orderItem={orderItem}/>
    },
    {
      module: 'rctmc',
      page: <LiveAnsweringConfig orderItem={orderItem}/>
    },
    {
      module: 'conciergetmc',
      page: <LiveAnsweringConfig orderItem={orderItem}/>
    },
    {
      module: 'analytix',
      page: <AnalytixConfig orderItem={orderItem}/>
    },
    {
      module: 'commscodev2e',
      page: <CommscodeConfig orderItem={orderItem}/>
    },
    {
      module: 'commscodelc',
      page: <CommscodeConfig orderItem={orderItem}/>
    },
    {
      module: 'businessintro',
      page: <BusinessIntroConfig orderItem={orderItem}/>
    },
    
  ]

  const module = provisioningModule.filter(config => {
    return config.module === orderItem.provisioning_module
  })

  orderItem.product_charges.charges.forEach(charge => {
    if (charge.amounts.subscription_fee) {
      totalSubscription += +charge.amounts.subscription_fee
    }
    if (charge.amounts.setup_fee) {
      totalOnceoff += +charge.amounts.setup_fee
    }
    if (charge.amounts.adhoc_fee) {
      totalOnceoff += +charge.amounts.adhoc_fee
    }
    charge.discounts.forEach(discount => {
      if (discount.charge_type === 'SETUP_FEE') {
        totalOnceoff -= +discount.discount_amount
      }
      if (discount.charge_type === 'SUBSCRIPTION_FEE') {
        totalSubscription -= +discount.discount_amount
      }
    })
  });

  const baseCharges = orderItem.product_charges.charges.filter(charge => {
    return charge.charge_name === 'Base charges'
  })

  const baseSubscriptionDiscount = baseCharges[0].discounts.filter(discount => {
    return discount.charge_type === 'SUBSCRIPTION_FEE'
  })

  const baseSetupDiscount = baseCharges[0].discounts.filter(discount => {
    return discount.charge_type === 'SETUP_FEE'
  })

  const adhocCharges = orderItem.product_charges.charges.filter(charge => {
    return charge.charge_name !== 'Base charges' && charge.amounts.adhoc_fee
  })

  const addOnCharges = orderItem.product_charges.charges.filter(charge => {
    return charge.charge_name !== 'Base charges' && !charge.amounts.adhoc_fee
  })

  const treeConnector = {
    borderLeft: '1px solid #ccc',
    borderBottom: '1px solid #ccc',
    width: '12px',
    height: '14px',
    display: 'inline-block',
    mr: 1,
    ml: 1,
    mt: '-3px',
    alignSelf: 'flex-start',
    flexShrink: 0,
  }

  return <Grid item xs={12} sx={{ mt: 2, mb: 2, pl: '50px!important', pr: '20px' }} key={orderItem.order_item_id}>
    <Grid container alignItems='center'>
      <Grid item xs={6}>
        <Typography sx={{ color: '#4D4D4D', fontWeight: 500, fontSize: '15px!important' }}>Your plan</Typography>
      </Grid>
      <Grid item xs={3} sx={{ textAlign: 'right' }}>
        <Typography sx={{ color: '#4D4D4D', fontWeight: 500, fontSize: '15px!important' }}>Subscription</Typography>
      </Grid>
      <Grid item xs={3} sx={{ textAlign: 'right' }}>
        <Typography sx={{ color: '#4D4D4D', fontWeight: 500, fontSize: '15px!important' }}>Once-off</Typography>
      </Grid>
    </Grid>
    <Grid container alignItems='center' sx={{ mt: 1 }}>
      <Grid item xs={6}>
        <Typography sx={{ fontWeight: 700, fontSize: '15px!important', color: '#242424' }}>{orderItem.plan_name}</Typography>
        {orderItem.reference && <Typography sx={{ fontSize: '13px!important', color: '#4D4D4D' }}>{orderItem.reference}</Typography>}
      </Grid>
      <Grid item xs={3} sx={{ textAlign: 'right' }}>
        {baseCharges[0].amounts.subscription_fee && <Typography sx={{ fontWeight: 700, fontSize: '15px!important', color: '#242424' }}>${baseCharges[0].amounts.subscription_fee}</Typography>}
      </Grid>
      <Grid item xs={3} sx={{ textAlign: 'right' }} />
    </Grid>
    {adhocCharges.map(charge => (
      <Grid container alignItems='center' sx={{ mt: 0.5 }} key={charge.order_item_charge_id}>
        <Grid item xs={6}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={treeConnector} />
            <Typography sx={{ fontSize: '15px!important', color: '#242424' }}>{charge.charge_name}</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} sx={{ textAlign: 'right' }} />
        <Grid item xs={3} sx={{ textAlign: 'right' }}>
          <Typography sx={{ fontWeight: 700, fontSize: '15px!important', color: '#242424' }}>${charge.amounts.adhoc_fee}</Typography>
        </Grid>
      </Grid>
    ))}
    {addOnCharges.map(charge => (
      <Grid container alignItems='center' sx={{ mt: 0.5 }} key={charge.order_item_charge_id}>
        <Grid item xs={6}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={treeConnector} />
            <Typography sx={{ fontSize: '15px!important', color: '#242424' }}>{charge.charge_name}</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} sx={{ textAlign: 'right' }}>
          {charge.amounts.subscription_fee && <Typography sx={{ fontWeight: 700, fontSize: '15px!important', color: '#242424' }}>${charge.amounts.subscription_fee}</Typography>}
        </Grid>
        <Grid item xs={3} sx={{ textAlign: 'right' }} />
      </Grid>
    ))}
    {baseCharges[0].amounts.setup_fee && <Grid container alignItems='center' sx={{ mt: 0.5 }}>
      <Grid item xs={6}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={treeConnector} />
          <Typography sx={{ fontSize: '15px!important', color: '#242424' }}>Setup fee</Typography>
        </Box>
      </Grid>
      <Grid item xs={3} sx={{ textAlign: 'right' }} />
      <Grid item xs={3} sx={{ textAlign: 'right' }}>
        <Typography sx={{ fontWeight: 700, fontSize: '15px!important', color: '#242424' }}>${baseCharges[0].amounts.setup_fee}</Typography>
      </Grid>
    </Grid>}
    {baseCharges[0].discounts.length > 0 && <Grid container alignItems='center' sx={{ mt: 0.5 }}>
      <Grid item xs={6}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={treeConnector} />
          <Typography sx={{ fontSize: '15px!important', color: '#242424' }}>Discount</Typography>
        </Box>
      </Grid>
      <Grid item xs={3} sx={{ textAlign: 'right' }}>
        {baseSubscriptionDiscount.length > 0 && <Typography sx={{ fontWeight: 700, fontSize: '15px!important', color: '#242424' }}>-${baseSubscriptionDiscount[0].discount_amount}</Typography>}
      </Grid>
      <Grid item xs={3} sx={{ textAlign: 'right' }}>
        {baseSetupDiscount.length > 0 && <Typography sx={{ fontWeight: 700, fontSize: '15px!important', color: '#242424' }}>-${baseSetupDiscount[0].discount_amount}</Typography>}
      </Grid>
    </Grid>}
    {module.length > 0 && <Box sx={{ mt: 0.5, display: 'flex' }}>
      <Box sx={treeConnector} />
      <Box sx={{ flex: 1 }}>
        <Button onClick={() => setShowConfig(prev => !prev)}
          endIcon={showConfig ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          sx={{ p: 0, minWidth: 0, textTransform: 'none' }}>
          <Typography sx={{ color: '#242424', fontWeight: 700, fontSize: '15px!important' }}>Configuration</Typography>
        </Button>
        <Collapse in={showConfig}>
          <Box sx={{ mt: 1, backgroundColor: '#F5F5F5', border: '1px solid #E0E0E0', borderRadius: '4px', p: 3 }}>
            {module[0].page}
          </Box>
        </Collapse>
      </Box>
    </Box>}
  </Grid>
}

export default VerificationNewItem